import React from 'react'
import ViewLabelValueField from './frontend_components/ViewLabelValueField'
import { Legenda } from './offerComponents/OfferSummary'
import useMediaQuery from '../hooks/useMediaQuery'
import VisDiv from './frontend_components/VisDiv'
import deadlines from './Deadlines'
import { deviceSubstitutionStatus } from '../lib/utils'
import TestButton from './frontend_components/TestButton'


const ClientDetailsReport = ({data={}}) => {
    const {sites, registers, devices, register, deviceNonConformities, hideLegenda, hideClientsAndSites, showToSupply, registerTemplate, client} = data
    const risk = (value) =>{
        if(value == 0) return {color: "green", riskLevel: "ASSENTE"}
        if(value <= 0.3) return {color: "yellow", riskLevel: "MODERATO"}
        if(value <= 0.6 ) return {color: "amber", riskLevel: "MEDIO"}
        if(value < 1 ) return {color: "red", riskLevel: "ALTO"}
        if(value >= 1 ) return {color: "darkRed", riskLevel: "CRITICO"}
    }


    const nPlessi = !Array.isArray(sites) ? [] : sites?.filter?.(x=> x?.status!=="ARCHIVIATO")?.length
    const nRegisters = !Array.isArray(registers) ? [] : registers?.filter?.(x=> x?.status!=="ARCHIVIATO")?.length

    const nPlessiToSubstitute = !Array.isArray(devices) ? [] : devices?.filter?.(device=> {
        const expiry = deadlines(device, registerTemplate)
        const deviceStatus = deviceSubstitutionStatus({device, deviceStatus:device?.status, deadlines:expiry, client})
        return deviceStatus=="DA SOSTITUIRE"})?.length
        
    const nPresidi = !Array.isArray(devices) ? [] : devices?.filter?.(x=> {
        if(showToSupply) return x?.status!=="ARCHIVIATO"
        return x?.status!=="ARCHIVIATO" && x?.status!=="DA FORNIRE"
    })?.length
    const filteredDeviceNonConformities =  !Array.isArray(deviceNonConformities) ? [] :  deviceNonConformities?.filter?.(x=> x?.status!=="ARCHIVIATO" && x?.status!=="COMPLETATO")
    const nNonConformita = filteredDeviceNonConformities?.length + nPlessiToSubstitute
    const riskRatio = () =>{ 
        const calc = (nNonConformita/nPresidi)
        const value = parseFloat(calc)?.toFixed(1)
        

        return ({value: !Number(value) ? 0 : value, color: risk(!Number(value) ? 0 : value)?.color, riskLevel:risk(!Number(value) ? 0 : value)?.riskLevel})
        }
    
    const mediumScreen = useMediaQuery("(min-width: 925px)")
    const ipadScreen = useMediaQuery("(min-width: 725px)")

    const labelValueDistance = () => {
        if(mediumScreen) return 4
        if(ipadScreen) return 2
        return 1
    } 
    const consoleData = {
        nPlessi, 
        deviceNonConformities, 
        registerIds:  deviceNonConformities?.map((x)=>x?.register?._ref),
        nRegisters, 
        nPresidi, 
        nNonConformita, 
        register, 
        riskRatio, 
        filteredDeviceNonConformities}


  return (
    <div style={{textAlign:"left"}}>
    <TestButton buttonId='kspoqwksopwqksd' message="test client details report" consoleData={consoleData} />
    <VisDiv rules={[!hideClientsAndSites]}><ViewLabelValueField label={"PLESSI"} value={nPlessi}highlight={"blue"}labelValueDistance = {labelValueDistance()}/></VisDiv>
    <VisDiv rules={[!hideClientsAndSites]}><ViewLabelValueField label={"REGISTRI"} value={nRegisters}highlight={"blue"}labelValueDistance = {labelValueDistance()}/></VisDiv>
    <ViewLabelValueField label={"PRESIDI"} value={nPresidi}highlight={"blue"}labelValueDistance = {labelValueDistance()}/>
    <ViewLabelValueField label={"NON CONFORMITA'"} value={nNonConformita}highlight={riskRatio()?.color}labelValueDistance = {labelValueDistance()}/>
    <ViewLabelValueField label={"COSTANTE DI RISCHIO"} value={riskRatio()?.value}highlight={riskRatio()?.color}labelValueDistance = {labelValueDistance()}/>
    <ViewLabelValueField label={"LIVELLO DI RISCHIO"} value={riskRatio()?.riskLevel}highlight={riskRatio()?.color}labelValueDistance = {labelValueDistance()}/>
    <VisDiv style={{marginBottom:"15px"}} rules={[!hideLegenda]}>
        <p>La costante di rischio è il rapporto tra il numero di presidi e il numero di non conformità. il livello di rischio viene calcolato come segue:</p>
        <Legenda label="ASSENTE" color="green" description="Se la costante è 0" />
        <Legenda label="MODERATO" color="yellow" description="Se la costante è minore di 0.3" />
        <Legenda label="MEDIO" color="amber" description="Se è compresa fra 0.3 e 0.6" />
        <Legenda label="ALTO" color="red" description="Se è compresa fra 0.6 e 1" />
        <Legenda label="CRITICO" color="darkRed" description="Se è maggiore di 1" />        
    </VisDiv>
</div>
  )
}

export default ClientDetailsReport
